"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fit = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const Box_1 = require("./Box");
exports.Fit = styled_1.default(Box_1.Box) `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

//# sourceMappingURL=Fit.js.map
